<template>
  <pt-old-to-new class="pt-old-to-new__page"></pt-old-to-new>
</template>

<script>
import PtOldToNew from 'cps/mall-manage/pt-old-to-new/withData'
export default {
  name: 'pt-old-to-new__view',
  components: {
    'pt-old-to-new': PtOldToNew
  }
}
</script>
